import { render } from "./SendMeetingRegarding.vue?vue&type=template&id=5dc99a1c&scoped=true"
import script from "./SendMeetingRegarding.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./SendMeetingRegarding.vue?vue&type=script&charset=utf-8&lang=js"

import "./SendMeetingRegarding.vue?vue&type=style&index=0&id=5dc99a1c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dc99a1c"]])

export default __exports__